import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { ConnectionService } from '../../services/connection.service'

/**
 * Der schmale Streifen „Keine Internetverbindung", der von selbst wieder verschwindet.
 *
 * Er zeigt sich ausschliesslich, wenn das GERAET ohne Netz ist (Entscheidung 2026-08-20). Antwortet
 * nur SaniUp gerade nicht (`unreachable`/`unavailable`, etwa waehrend eines Deploy-Neustarts),
 * bleibt der Kopf leer: dieser Fall ist meist in Sekunden vorbei und heilt sich im Hintergrund
 * ohnehin selbst, ein Streifen ueber der ganzen Breite waere dafuer zu laut. Sichtbar wird er dann
 * dort, wo er wirklich stoert — im `lib-error-state` der betroffenen Ansicht.
 *
 * Die Selbstheilung im `ConnectionService` laeuft davon unberuehrt weiter; hier haengt nur die
 * Anzeige. Der Streifen steht im Fluss, nicht als Overlay (dieselbe Entscheidung wie beim
 * `lib-stage-bar`: ein Overlay lag ueber dem Seitenkopf und verdeckte dort Inhalt und Klicks).
 */
@Component({
  selector: 'lib-connection-banner',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './connection-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './connection-banner.component.scss',
  host: {
    '[class.hidden]': '!isOffline()',
  },
})
export class ConnectionBannerComponent {
  readonly connectionService = inject(ConnectionService)

  readonly isOffline = computed(() => this.connectionService.connectionState() === 'offline')
}
